import { Suspense, lazy } from "react";
import { Helmet } from "react-helmet-async";

import SuspenseLoader from "src/components/SuspenseLoader";

const Loader = (Component) => (props) =>
  (
    <Suspense fallback={<SuspenseLoader />}>
      <Component {...props} />
    </Suspense>
  );

const References = Loader(lazy(() => import("src/content/references")));

const referenceRoutes = [
  {
    path: "/",
    element: (
      <>
        <Helmet>
          <title> Referanslar </title>
        </Helmet>
        <References />
      </>
    ),
  },
];

export default referenceRoutes;
